import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { Product } from "../data";

export default function ProductCard({ product, index = 0 }: { product: Product; index?: number }) {
  return <article className={`product-card ${index === 0 ? "product-card-featured" : ""}`} data-testid={`product-card-${product.slug}`}>
    <div className="product-card-image"><img src={product.image} alt={`${product.name} industrial application`} loading="lazy" /><span className="image-index">{String(index + 1).padStart(2, "0")}</span></div>
    <div className="product-card-body"><p className="eyebrow">{product.category}</p><h3>{product.name}</h3><p>{product.summary}</p><Link to={`/products/${product.slug}`} className="text-link" data-testid={`product-link-${product.slug}`}>View specifications <ArrowUpRight size={16} /></Link></div>
  </article>;
}
